import { BankGateway } from "@/models/club";

export const bankGatewayLabel = (gateway?: BankGateway | null): string => {
  switch (gateway) {
    case BankGateway.Value1: return "تست";
    case BankGateway.Value2: return "زرین پال";
    case BankGateway.Value3: return "وندار";
    case BankGateway.Value4: return "اسنپ پی";
    default: return "نامشخص";
  }
};
